<template>
  <div>
    <div v-if="!isFlag" class="Register">
      <img src="../assets/logo.png" class="logo" />
      <input
        type="tel"
        placeholder="请输入手机号"
        class="phone"
        v-model="account"
        maxlength="11"
      />
      <div class="code-box flex-sb-c">
        <input
          type="tel"
          placeholder="请输入验证码"
          class="code-input"
          v-model="code"
          maxlength="6"
        />
        <div class="code tar" @click="getCode" v-if="getShow">获取验证码</div>
        <div class="code tar" v-else>重新发送({{ second }}s)</div>
      </div>
      <div class="full-btn" @click="submit">注册</div>
      <p class="tip-text">
        温馨提示：注册成功后，若无法自动跳转到下载页面，可前往各大应用商城搜索“分之道”自行下载。
      </p>
    </div>
    <div style="margin: 20px auto;text-align: center;font-weight: bold;" class="not-found" v-else>404 Not Found</div>
  </div>
</template>

<script>
import { post } from "../api/axios";

export default {
  name: "Register",
  data() {
    return {
      second: "60",
      getShow: true,
      account: "",
      code: "",
      userId: "",
      agentId: "",
      isOpen: false,
      isFlag:false,
    };
  },
  created() {
    this.userId = this.$route.query.userId;
    this.agentId = this.$route.query.agentId;
    this.isFlag = this.agentId === '1c466aad25be11ecb4d200163e067b9d';
    if (!this.userId && !this.agentId) {
      this.$message("邀请码获取失败!");
    }
  },
  methods: {
    getCode() {
      if (!this.userId && !this.agentId) {
        this.$message("邀请码不存在!");
        return;
      }
      if (this.account == "") {
        this.$message("请输入手机号码");
        return;
      }
      post("boot-app/api/v2/app/auth/sendSms", {
        account: this.account,
        code: "UserRegistration",
      })
        .then((res) => {
          if (res.code == 200) {
            this.$message("验证码发送成功");
            this.getShow = false;
            let timer = setInterval(() => {
              --this.second;
              if (this.second == 0) {
                clearInterval(timer);
                this.getShow = true;
                this.second = "60";
              }
            }, 1000);
          } else {
            this.$message(res.message);
          }
        })
        .catch((err) => {
          this.$message(err.message);
        });
    },
    submit() {
      if (this.isOpen) {
        return;
      }
      if (!this.userId && !this.agentId) {
        this.$message("邀请码不存在!");
        return;
      }
      if (this.account == "") {
        this.$message("请输入手机号码");
        return;
      }
      if (this.code == "") {
        this.$message("请输入验证码");
        return;
      }
      this.isOpen = true;
      post("boot-app/api/v2/app/auth/sweepCode", {
        account: this.account,
        code: this.code,
        inviteUserId: this.userId,
        inviteAgentId: this.agentId,
      })
        .then((res) => {
          if (res.code == 200) {
            console.log(res);
            this.$message("成功");
            let timeOut;
            if (this.userId == 288) {
              clearTimeout(timeOut);
              timeOut = setTimeout(() => {
                this.$router.push({
                  name: "Download",
                  query: { userId: this.userId },
                });
              }, 1000);
            } else {
              clearTimeout(timeOut);
              timeOut = setTimeout(() => {
                this.$router.push({
                  name: "Download",
                });
              }, 1000);
            }
          } else {
            this.$message(res.message);
          }
        })
        .catch((err) => {
          this.$message(err);
        })
        .finally((_) => {
          this.isOpen = false;
        });
    },
  },
  mounted() {
    document.title = "注册分之道";
  },
};
</script>

<style scoped lang="scss">
.Register {
  .logo {
    margin-bottom: 180px;
    padding-top: 200px;
    width: 34%;
    height: auto;
  }

  .phone {
    width: 640px;
    padding: 24px 0;
    border-bottom: 1px solid #e0e0e0;
    margin: 0 auto 40px;
    display: block;
  }

  .code-box {
    margin: 0 auto 140px;
    width: 640px;
    padding-bottom: 2px;
    border-bottom: 1px solid #e0e0e0;

    .code-input {
      box-sizing: border-box;
      padding: 24px 0;
    }

    .code {
      white-space: nowrap;
      color: $color;
    }
  }
  .tip-text {
    color: #666;
    width: 80%;
    margin: 36px auto;
    line-height: 42px;
  }
}
</style>
